/*! Veniti Ambient Highlighter v5 — area-based winner (most visible), instant response, slow fade */
(() => {
  document.body.classList.add('ambient-on');

  // Minimal init to avoid black screen when scroll is locked (no-Scroll hero etc.)
  (function(){
    function initDefault(){
      var first = document.querySelector('.shopify-section.ambient-default') ||
                  document.querySelector('.shopify-section:not(.no-ambient)');
      if (first && !first.classList.contains('is-active')){
        first.classList.add('is-active');
      document.body.classList.add('ambient-has-active');try{window.dispatchEvent(new Event('scroll'));}catch(e){}setTimeout(function(){ try{window.dispatchEvent(new Event('scroll'));}catch(e){} }, 50);setTimeout(function(){ try{window.dispatchEvent(new Event('resize'));}catch(e){} }, 80);}
    }
    if (document.readyState !== 'loading'){ initDefault(); }
    else { document.addEventListener('DOMContentLoaded', initDefault); }
  })();


  // Global scrim
  let scrim = document.querySelector('.ambient-scrim');
  if (!scrim){
    scrim = document.createElement('div');
    scrim.className = 'ambient-scrim';
    document.body.appendChild(scrim);
  }

  let sections = Array.from(document.querySelectorAll('.shopify-section'));
  const candidates = () => sections.filter(s => !s.classList.contains('no-ambient'));

  let active = null;
  let ticking = false;
  const HYSTERESIS = 0.02;   // new winner must exceed current by 2% of viewport area

  function refreshSections(){
    sections = Array.from(document.querySelectorAll('.shopify-section'));
  }

  function visibleAreaRatio(el, vw, vh){
    const r = el.getBoundingClientRect();
    const left = Math.max(0, Math.min(vw, r.left));
    const right = Math.max(0, Math.min(vw, r.right));
    const top = Math.max(0, Math.min(vh, r.top));
    const bottom = Math.max(0, Math.min(vh, r.bottom));
    const w = Math.max(0, right - left);
    const h = Math.max(0, bottom - top);
    const area = w * h;
    return area / (vw * vh);
  }

  function pickActive(){
    const vw = window.innerWidth || document.documentElement.clientWidth;
    const vh = window.innerHeight || document.documentElement.clientHeight;
    const list = candidates();
    if (!list.length) return;

    let winner = null, best = -1;

    for (const s of list){
      const ratio = visibleAreaRatio(s, vw, vh);
      if (ratio <= 0) continue;
      if (ratio > best){
        best = ratio;
        winner = s;
      }
    }

    if (!winner) return;

    if (active && winner !== active){
      const currentRatio = visibleAreaRatio(active, vw, vh);
      if (best < currentRatio + HYSTERESIS) return;
    }

    if (winner !== active){
      if (active) active.classList.remove('is-active');
      winner.classList.add('is-active');
      active = winner;
    document.body.classList.add('ambient-has-active');
    }
  }

  function onScroll(){
    if (!ticking){
      requestAnimationFrame(() => { pickActive(); ticking = false; });
      ticking = true;
    }
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  window.addEventListener('orientationchange', onScroll);
  document.addEventListener('shopify:section:load', () => { refreshSections(); onScroll(); });
  document.addEventListener('shopify:section:unload', () => { refreshSections(); onScroll(); });

  onScroll();
})();